export default __webpack_public_path__ + "scripts/resource/e90e1e6d5f1328c6bb6b90caa1aa1327.svg";